import React from "react";
import { Form, Input, Radio, Select, DatePicker } from "antd";
import moment from "moment";
const { Option } = Select;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onChange,
  onSearch,
  technicalSkills,
  itemData
}) {
  const isEdit = itemData !== null;
  return (
    <Form {...formItemLayout}>
      <Form.Item label="Certification Name" className="formsteponeinout">
        {getFieldDecorator("certificationName", {
          initialValue: itemData ? itemData.certificationName : undefined,
          rules: [
            {
              required: true,
              message: "Please enter Certification Name"
            }
          ]
        })(<Input placeholder="Enter Certification Name" disabled={isEdit} />)}
      </Form.Item>
      <Form.Item
        label="What skills you have learnt/worked to get this Certification?"
        className="formsteponeinout"
      >
        {getFieldDecorator("skillLearntAtCertification", {
          initialValue: itemData
            ? itemData.skillLearntAtCertification
            : undefined,
          rules: [
            {
              required: true,
              message: "List down skills you learnt at this Certification"
            }
          ]
        })(
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Search or Add new technologies"
          >
            {children}
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Authority or Company Name issued this Certification"
        className="formsteponeinout"
      >
        {getFieldDecorator("certificationAuthority", {
          initialValue: itemData ? itemData.certificationAuthority : undefined,
          rules: [
            {
              required: true,
              message: "Please enter name of Company/Authority"
            }
          ]
        })(<Input placeholder="Enter name of Company/Authority" />)}
      </Form.Item>

      <Form.Item
        label="Have you got this certification at an offline event or online website?"
        className="formsteponeinout"
      >
        {getFieldDecorator("certificationType", {
          initialValue: itemData ? itemData.certificationType : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="offline">Offline</Radio>
            <Radio value="online">Online</Radio>
            <Radio value="Other">Other</Radio>
          </Radio.Group>
        )}
      </Form.Item>

      <Form.Item
        label="Certification Date ?(Approx)"
        className="formsteponeinout"
      >
        {getFieldDecorator("certificationDate", {
          initialValue: itemData
            ? moment(itemData.certificationDate, "MMMM Do YYYY")
            : undefined,
          rules: [
            {
              required: true,
              message: "Tell us the approx Certification Date"
            }
          ]
        })(<DatePicker />)}
      </Form.Item>

      <Form.Item
        label="URL of certification / Google Drive Certification Link"
        className="formsteponeinout"
      >
        {getFieldDecorator("certificationURL", {
          initialValue: itemData ? itemData.certificationURL : " "
        })(<Input placeholder="Enter URL of Certification / Google Drive Link (If any)" />)}
      </Form.Item>
    </Form>
  );
}
const children = [
  <Option key={"C"} value="C">
    C
  </Option>,
  <Option key={"C++"} value="C++">
    C++
  </Option>,
  <Option key={"C#"} value="C#">
    C#
  </Option>,
  <Option key={"Java"} value="Java">
    Java
  </Option>,
  <Option key={"Python"} value="Python">
    Python
  </Option>,
  <Option key={"Javascript"} value="Javascript">
    JavaScript
  </Option>,
  <Option key={"PHP"} value="PHP">
    PHP
  </Option>,
  <Option key={"Swift"} value="Swift">
    Swift
  </Option>,
  <Option key={"Ruby"} value="Ruby">
    Ruby
  </Option>,
  <Option key={"R"} value="R">
    R-Programming
  </Option>,
  <Option key={"VLSI"} value="VLSI">
    VLSI
  </Option>,
  <Option key={"Html"} value="Html">
    HTML
  </Option>,
  <Option key={"CSS"} value="CSS">
    CSS
  </Option>,
  <Option key={"Bootstrap"} value="Bootstrap">
    Bootstrap
  </Option>,
  <Option key={"React"} value="React">
    React
  </Option>,
  <Option key={"AngularJS"} value="AngularJS">
    Angular JS
  </Option>,
  <Option key={"VueJS"} value="VueJS">
    VueJS
  </Option>,
  <Option key={"NodeJS"} value="NodeJS">
    NodeJS
  </Option>,
  <Option key={"Android"} value="Android">
    Android Development
  </Option>,
  <Option key={"IOS"} value="IOS">
    IOS Development
  </Option>,
  <Option key={"HTML"} value="HTML">
    Blockchain
  </Option>,
  <Option key={"ML"} value="ML">
    Machine Learning
  </Option>,
  <Option key={"AI"} value="AI">
    Artificial Intelligence
  </Option>,
  <Option key={"IoT"} value="IoT">
    Internet Of Things
  </Option>,
  <Option key={"Robotics"} value="Robotics">
    Robotics
  </Option>,
  <Option key={"SQL"} value="SQL">
    SQL
  </Option>,
  <Option key={"NoSQL"} value="NoSQL">
    NoSQL
  </Option>,
  <Option key={"CAD"} value="CAD">
    Auto CAD
  </Option>
];
